// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isCompanySecurityEventConfigResult = objectOf({
  s3_data_export_bucket_name: maybe(string),
  s3_data_export_bucket_folder: maybe(string),
  s3_access_key: maybe(string),
  s3_role_arn: maybe(string),
  s3_auth_type: maybe(number),
  s3_external_id: maybe(string),
  s3_account_id: string,
  default_warehouse: maybe(number),
});
